/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { IUserManager, IUserManagerInterface } from "../IUserManager";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IUnlimitedOwner",
        name: "unlimitedOwner_",
        type: "address",
      },
      {
        internalType: "contract IController",
        name: "controller_",
        type: "address",
      },
      {
        internalType: "contract ITradeManager",
        name: "tradeManager_",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "feeIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "feeSize",
        type: "uint256",
      },
    ],
    name: "FeeSizeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "feeIndex",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "feeVolume",
        type: "uint256",
      },
    ],
    name: "FeeVolumeUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "enum Tier",
        name: "tier",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "validUntil",
        type: "uint256",
      },
    ],
    name: "UserManualTierUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "referrer",
        type: "address",
      },
    ],
    name: "UserReferrerAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "tradePair",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "volume",
        type: "uint256",
      },
    ],
    name: "UserVolumeAdded",
    type: "event",
  },
  {
    inputs: [],
    name: "DAYS_IN_WORD",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
      {
        internalType: "uint40",
        name: "volume_",
        type: "uint40",
      },
    ],
    name: "addUserVolume",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "controller",
    outputs: [
      {
        internalType: "contract IController",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeSizes",
    outputs: [
      {
        internalType: "uint8",
        name: "baseFee",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "fee1",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "fee2",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "fee3",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "fee4",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "fee5",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "fee6",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "feeVolumes",
    outputs: [
      {
        internalType: "uint40",
        name: "volume1",
        type: "uint40",
      },
      {
        internalType: "uint40",
        name: "volume2",
        type: "uint40",
      },
      {
        internalType: "uint40",
        name: "volume3",
        type: "uint40",
      },
      {
        internalType: "uint40",
        name: "volume4",
        type: "uint40",
      },
      {
        internalType: "uint40",
        name: "volume5",
        type: "uint40",
      },
      {
        internalType: "uint40",
        name: "volume6",
        type: "uint40",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
    ],
    name: "getUser30DaysVolume",
    outputs: [
      {
        internalType: "uint256",
        name: "user30dayVolume",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
    ],
    name: "getUserFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
    ],
    name: "getUserManualTier",
    outputs: [
      {
        internalType: "enum Tier",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
    ],
    name: "getUserReferrer",
    outputs: [
      {
        internalType: "address",
        name: "referrer",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
    ],
    name: "getUserTier",
    outputs: [
      {
        internalType: "enum Tier",
        name: "userTier",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
    ],
    name: "getUserVolumeTier",
    outputs: [
      {
        internalType: "enum Tier",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint8[7]",
        name: "feeSizes_",
        type: "uint8[7]",
      },
      {
        internalType: "uint32[6]",
        name: "feeVolumes_",
        type: "uint32[6]",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "manualUserTiers",
    outputs: [
      {
        internalType: "enum Tier",
        name: "tier",
        type: "uint8",
      },
      {
        internalType: "uint32",
        name: "validUntil",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "feeIndexes",
        type: "uint256[]",
      },
      {
        internalType: "uint8[]",
        name: "feeSizes_",
        type: "uint8[]",
      },
    ],
    name: "setFeeSizes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256[]",
        name: "feeIndexes",
        type: "uint256[]",
      },
      {
        internalType: "uint32[]",
        name: "feeVolumes_",
        type: "uint32[]",
      },
    ],
    name: "setFeeVolumes",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "enum Tier",
        name: "tier",
        type: "uint8",
      },
      {
        internalType: "uint32",
        name: "validUntil",
        type: "uint32",
      },
    ],
    name: "setUserManualTier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user_",
        type: "address",
      },
      {
        internalType: "address",
        name: "referrer_",
        type: "address",
      },
    ],
    name: "setUserReferrer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "tradeManager",
    outputs: [
      {
        internalType: "contract ITradeManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unlimitedOwner",
    outputs: [
      {
        internalType: "contract IUnlimitedOwner",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "userDailyVolumes",
    outputs: [
      {
        internalType: "uint40",
        name: "zero",
        type: "uint40",
      },
      {
        internalType: "uint40",
        name: "one",
        type: "uint40",
      },
      {
        internalType: "uint40",
        name: "two",
        type: "uint40",
      },
      {
        internalType: "uint40",
        name: "three",
        type: "uint40",
      },
      {
        internalType: "uint40",
        name: "four",
        type: "uint40",
      },
      {
        internalType: "uint40",
        name: "five",
        type: "uint40",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type IUserManagerConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: IUserManagerConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class IUserManager__factory extends ContractFactory {
  constructor(...args: IUserManagerConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    unlimitedOwner_: PromiseOrValue<string>,
    controller_: PromiseOrValue<string>,
    tradeManager_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<IUserManager> {
    return super.deploy(
      unlimitedOwner_,
      controller_,
      tradeManager_,
      overrides || {}
    ) as Promise<IUserManager>;
  }
  override getDeployTransaction(
    unlimitedOwner_: PromiseOrValue<string>,
    controller_: PromiseOrValue<string>,
    tradeManager_: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      unlimitedOwner_,
      controller_,
      tradeManager_,
      overrides || {}
    );
  }
  override attach(address: string): IUserManager {
    return super.attach(address) as IUserManager;
  }
  override connect(signer: Signer): IUserManager__factory {
    return super.connect(signer) as IUserManager__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): IUserManagerInterface {
    return new utils.Interface(_abi) as IUserManagerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IUserManager {
    return new Contract(address, _abi, signerOrProvider) as IUserManager;
  }
}
